import ActionTypes from '../types.js'
import ErrorTypes from '@constants/error_types.js'
import {
  handleBulkChangeCommentsVisibilitySuccess,
  handleBulkChangeCommentsVisibilityError,
} from './bulk_comment_server_actions.js'
import CommentWebAPI from '@api/comment_web_api.js'

export function bulkChangeCommentsVisibility(ids, visible) {
  return (dispatch, getState) => {
    dispatch(bulkChangeVisibilityStart(visible))
    CommentWebAPI.changeCommentsVisibility(ids, visible).then(
      response => {
        dispatch(bulkChangeVisibilitySuccess(visible))
        dispatch(handleBulkChangeCommentsVisibilitySuccess(response, ids))
      },
      error => {
        if (error.message === ErrorTypes.CALL_ALREADY_IN_PROGRESS) {
          return
        }
        dispatch(bulkChangeVisibilityError(visible))
        dispatch(handleBulkChangeCommentsVisibilityError(error, ids))
      }
    )
  }
}

function bulkChangeVisibilityStart(visible) {
  const type = visible ? ActionTypes.BULK_SHOW_COMMENTS_START : ActionTypes.BULK_HIDE_COMMENTS_START
  return { type }
}

function bulkChangeVisibilitySuccess(visible) {
  const type = visible ? ActionTypes.BULK_SHOW_COMMENTS_SUCCESS : ActionTypes.BULK_HIDE_COMMENTS_SUCCESS
  return { type }
}

function bulkChangeVisibilityError(visible) {
  const type = visible ? ActionTypes.BULK_SHOW_COMMENTS_ERROR : ActionTypes.BULK_HIDE_COMMENTS_ERROR
  return { type }
}
